export default "__VITE_ASSET__3ee130eb__"